const useHandleRadioChange = (setIsCurrentlyDraft, setChangeMade) => (isCurrentlyDraft, isDraft, changeMade) => {
  setIsCurrentlyDraft(isCurrentlyDraft);

  if (isCurrentlyDraft === isDraft) {
    setChangeMade(false);

    return;
  }

  setChangeMade(changeMade);
};

export default useHandleRadioChange;
